const LOAD_OFFERED           = 'LOAD_OFFERED'
const LOAD_OFFERED_SUCCESS   = 'LOAD_OFFERED_SUCCESS'
const LOAD_OFFERED_FAILED    = 'LOAD_OFFERED_FAILED'
const UNMOUNT_OFFERED        = 'UNMOUNT_OFFERED'
const initialState = {
  loading: true,
  data: null,
  message: null,
}
const offeredReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_OFFERED:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_OFFERED_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_OFFERED_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_OFFERED:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}
export default offeredReducer;